import { c as _c } from "react/compiler-runtime";
import { EMAIL_STATISTICS_API } from 'modules/email-statistics/api/email-statistics-api';
import { EmailStatisticsChartsInterface, EmailStatisticsFilterInterface } from 'modules/email-statistics/types/email-statistics-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useEmailStatisticsCharts = filter => {
  const $ = _c(5);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const filterApi = `${filter.dateSince !== null ? `filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ""}`;
  let t1;
  if ($[1] !== filter.dateSince || $[2] !== filterApi || $[3] !== user) {
    t1 = () => {
      if (!user || filter.dateSince === null) {
        return;
      }
      return `${EMAIL_STATISTICS_API}/chart?${filterApi}`;
    };
    $[1] = filter.dateSince;
    $[2] = filterApi;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useSWR(t1, fetcher);
};